// extracted by mini-css-extract-plugin
module.exports = {"container":"BaseCardTextHeader_container__HA3z6"};